"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfileNoteCreateDto = instanceOfProfileNoteCreateDto;
exports.ProfileNoteCreateDtoFromJSON = ProfileNoteCreateDtoFromJSON;
exports.ProfileNoteCreateDtoFromJSONTyped = ProfileNoteCreateDtoFromJSONTyped;
exports.ProfileNoteCreateDtoToJSON = ProfileNoteCreateDtoToJSON;
exports.ProfileNoteCreateDtoToJSONTyped = ProfileNoteCreateDtoToJSONTyped;
/**
 * Check if a given object implements the ProfileNoteCreateDto interface.
 */
function instanceOfProfileNoteCreateDto(value) {
    if (!('note' in value) || value['note'] === undefined)
        return false;
    return true;
}
function ProfileNoteCreateDtoFromJSON(json) {
    return ProfileNoteCreateDtoFromJSONTyped(json, false);
}
function ProfileNoteCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'note': json['note'],
    };
}
function ProfileNoteCreateDtoToJSON(json) {
    return ProfileNoteCreateDtoToJSONTyped(json, false);
}
function ProfileNoteCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'note': value['note'],
    };
}
//# sourceMappingURL=ProfileNoteCreateDto.js.map